import React, { useState } from "react";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";

export default function HomeHistory() {
    const [activeKey, setActiveKey] = useState("year-tab1");
    const [progressWidth, setProgressWidth] = useState(0);

    const navItems = [
    { key: "year-tab1"},
    { key: "year-tab2"},
    { key: "year-tab3"},
    { key: "year-tab4"},
    { key: "year-tab5"},
    { key: "year-tab6"},
    { key: "year-tab7"},
    { key: "year-tab8"},
    ];

    const handleSelect = (key) => {
    setActiveKey(key);
    const index = navItems.findIndex(item => item.key === key);
    const total = navItems.length - 1;
    const percent = (index / total) * 100;
    setProgressWidth(percent);
    };
    
  return (
    <>
    <section className="home-history">
        <div className="container">
          <div className="row">

            <div className="col-lg-12">
                <Tab.Container activeKey={activeKey} onSelect={handleSelect}>
                    <Tab.Content className="yearstab-content">
                        <Tab.Pane eventKey="year-tab1">
                            <div className='yeardetail'>
                                <img src="/image/history-image-1.webp" className="img-responsive" alt="school" loading="lazy" decoding="async"/>
                                <div>
                                    <h3 className="heading">1988 - Foundation Year</h3>
                                    <p>Lucknow Public School (Sector-D) was established under the vision of Late Shri C.P. Singh with a mission to provide quality education in Lucknow.</p>
                                </div>
                            </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="year-tab2">
                            <div className='yeardetail'>
                                <img src="/image/history-image-2.webp" className="img-responsive" alt="school" loading="lazy" decoding="async"/>
                                <div>
                                    <h4 className="heading">1997 - branch launch</h4>
                                    <p>Lucknow Public Schools expanded with the Sector-I branch, which represents an important turning point in delivering quality education in the city.</p>
                                </div>
                            </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="year-tab3">
                            <div className='yeardetail'>
                                <img src="/image/history-image-3.webp" className="img-responsive" alt="school" loading="lazy" decoding="async"/>
                                <div>
                                    <h4 className="heading">2006 - branch launch</h4>
                                    <p>2006 saw the dual launch of Jankipuram in Lucknow and Ahiyaraipur in Raebareli, extending LPS’s values-based education to new communities.</p>
                                </div>
                            </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="year-tab4">
                            <div className='yeardetail'>
                                <img src="/image/history-image-4.webp" className="img-responsive" alt="school" loading="lazy" decoding="async"/>
                                <div>
                                    <h4 className="heading">2009 - branch launch</h4>
                                    <p>The South City campus opened in 2009, offering state-of-the-art facilities and a nurturing academic environment in one of Lucknow’s fastest-growing areas.</p>
                                </div>
                            </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="year-tab5">
                            <div className='yeardetail'>
                                <img src="/image/history-image-5.webp" className="img-responsive" alt="school" loading="lazy" decoding="async"/>
                                <div>
                                    <h4 className="heading">2015 - branch launch</h4>
                                    <p>In 2015, LPS stepped into Unnao with its Sector-B branch, bringing structured learning and growth opportunities to students in the region.</p>
                                </div>
                            </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="year-tab6">
                            <div className='yeardetail'>
                                <img src="/image/history-image-6.webp" className="img-responsive" alt="school" loading="lazy" decoding="async"/>
                                <div>
                                    <h4 className="heading">2016 - branch launch</h4>
                                    <p>LPS strengthened its presence in Raebareli with the Pragatipuram branch, focussing on academic excellence and holistic student development.</p>
                                </div>
                            </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="year-tab7">
                            <div className='yeardetail'>
                                <img src="/image/history-image-7.webp" className="img-responsive" alt="school" loading="lazy" decoding="async"/>
                                <div>
                                    <h4 className="heading">2020 - branch launch</h4>
                                    <p>In 2020, LPS added Eldeco in Lucknow and Sector-C in Unnao, furthering its mission of accessible, modern education across urban and semi-urban areas.</p>
                                </div>
                            </div>
                        </Tab.Pane>

                        <Tab.Pane eventKey="year-tab8">
                            <div className='yeardetail'>
                                <img src="/image/history-image-8.webp" className="img-responsive" alt="school" loading="lazy" decoding="async"/>
                                <div>
                                    <h4 className="heading">2023 - branch launch</h4>
                                    <p>LPS Ansal was launched in 2023, combining innovative learning methods with a student-centric environment in one of Lucknow’s premier residential areas.</p>
                                </div>
                            </div>
                        </Tab.Pane>
                    </Tab.Content>

                    <Nav className="yearstab-link">
                        <Nav.Item className={activeKey === "year-tab1" ? "activedot" : ""}>
                            <Nav.Link eventKey="year-tab1">1988</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className={activeKey === "year-tab2" ? "activedot" : ""}>
                            <Nav.Link eventKey="year-tab2">1997</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className={activeKey === "year-tab3" ? "activedot" : ""}>
                            <Nav.Link eventKey="year-tab3">2006</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className={activeKey === "year-tab4" ? "activedot" : ""}>
                            <Nav.Link eventKey="year-tab4">2009</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className={activeKey === "year-tab5" ? "activedot" : ""}>
                            <Nav.Link eventKey="year-tab5">2015</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className={activeKey === "year-tab6" ? "activedot" : ""}>
                            <Nav.Link eventKey="year-tab6">2016</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className={activeKey === "year-tab7" ? "activedot" : ""}>
                            <Nav.Link eventKey="year-tab7">2020</Nav.Link>
                        </Nav.Item>
                        <Nav.Item className={activeKey === "year-tab8" ? "activedot" : ""}>
                            <Nav.Link eventKey="year-tab8">2023</Nav.Link>
                        </Nav.Item>

                        <div className="history-progress" >
                            <div style={{ width: `${progressWidth}%` }}></div>
                        </div>
                    </Nav>
                </Tab.Container>
            </div>

          </div>
        </div>
    </section>
    </>
  )
}
